import {
  CREATE_JOB_FAILURE,
  CREATE_JOB_REQUEST,
  CREATE_JOB_SUCCESS,
  FETCH_JOBS_FAILURE,
  FETCH_JOBS_REQUEST,
  FETCH_JOBS_SUCCESS,
  RUN_JOB_REQUEST,
  RUN_JOB_SUCCESS,
  RUN_JOB_FAILURE
} from "../../common/actionTypes";

const initialState = {
  jobs: [],
  loading: false,
  error: null,
  jobCreated: false,
  runningJob: false,
  runJobError: null,
};

const jobReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOBS_REQUEST:
    case CREATE_JOB_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        jobCreated: false,
      };

    case FETCH_JOBS_SUCCESS:
      return {
        ...state,
        jobs: action.payload,
        loading: false,
      };

    case CREATE_JOB_SUCCESS:
      return {
        ...state,
        jobs: [...state.jobs, action.payload],
        loading: false,
        jobCreated: true,
      };

    case FETCH_JOBS_FAILURE:
    case CREATE_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        jobCreated: false,
      };

    // Run job actions
    case RUN_JOB_REQUEST:
      return {
        ...state,
        runningJob: true,
        runJobError: null,
      };

    case RUN_JOB_SUCCESS:
      return {
        ...state,
        runningJob: false,
      };

    case RUN_JOB_FAILURE:
      return {
        ...state,
        runningJob: false,
        runJobError: action.payload,
      };

    default:
      return state;
  }
};

export default jobReducer;

